import NoteShow from "./NoteShow";
import NotesIndex from "./NotesIndex";
import { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import getRootData from 'utils/getRootData';
import { UserInfo } from 'types/user_info';

interface RootData {
  userInfo: UserInfo;
}

const NotesMain = () => {
  const { pboard, id } = useParams();
  const { userInfo } = getRootData<RootData>() ?? { userInfo: null };

  // <div className="mx-auto max-w lg:max-w-5xl bg-white p-6 pt-10 pb-20">
  return (
    <div className="page-wrapper board-wrapper mx-auto max-w-6xl bg-white/95 p-6 md:p-10 rounded-none md:rounded-2xl shadow-[0_1px_3px_rgba(31,45,36,0.05),0_8px_24px_rgba(31,45,36,0.04)] border border-[#e8dfcf]">
      {id ? <NoteShow currentNoteId={parseInt(id)} userInfo={userInfo} pboard={pboard} /> : <NotesIndex userInfo={userInfo} pboard={pboard} />}
    </div>
  );
};

export default NotesMain;
